import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Gear14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_97)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 4.25C5.48122 4.25 4.25 5.48122 4.25 7C4.25 8.51878 5.48122 9.75 7 9.75C8.51878 9.75 9.75 8.51878 9.75 7C9.75 5.48122 8.51878 4.25 7 4.25ZM5.75 7C5.75 6.30964 6.30964 5.75 7 5.75C7.69036 5.75 8.25 6.30964 8.25 7C8.25 7.69036 7.69036 8.25 7 8.25C6.30964 8.25 5.75 7.69036 5.75 7Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.00012 0.843574C9.00012 0.377681 8.62244 0 8.15654 0H5.84369C5.3778 0 5.00012 0.377681 5.00012 0.843574V1.13888C5.00012 2.35408 3.65009 3.08287 2.63414 2.41611C2.28324 2.18581 1.81227 2.28178 1.57945 2.63101L0.500117 4.25C0.223974 4.66421 0.335903 5.22386 0.750117 5.5C1.82048 6.21358 1.82048 7.78642 0.750116 8.5C0.335903 8.77614 0.223974 9.33579 0.500116 9.75L1.57791 11.3667C1.81109 11.7165 2.28366 11.811 2.63342 11.5778C3.64506 10.9034 5.00012 11.6286 5.00012 12.8444V13.1556C5.00012 13.6219 5.37817 14 5.84453 14H8.15571C8.62206 14 9.00012 13.6219 9.00012 13.1556V12.8444C9.00012 11.6286 10.3552 10.9034 11.3668 11.5778C11.7166 11.811 12.1891 11.7165 12.4223 11.3667L13.5001 9.75C13.7763 9.33579 13.6643 8.77614 13.2501 8.5C12.1797 7.78642 12.1797 6.21358 13.2501 5.5C13.6643 5.22386 13.7763 4.66421 13.5001 4.25L12.4208 2.63101C12.188 2.28178 11.717 2.18581 11.3661 2.41611C10.3501 3.08287 9.00012 2.35408 9.00012 1.13888V0.843574ZM2.46998 3.99937C4.25385 4.63587 6.25667 3.44307 6.47964 1.5H7.5206C7.74356 3.44307 9.74638 4.63587 11.5303 3.99937L11.9494 4.62812C10.6133 5.91425 10.6133 8.08575 11.9494 9.37188L11.5352 9.99325C9.74841 9.34699 7.73259 10.5449 7.51875 12.5H6.48149C6.26764 10.5449 4.25183 9.34699 2.46506 9.99325L2.05081 9.37188C3.38692 8.08575 3.38692 5.91425 2.05081 4.62812L2.46998 3.99937Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_97'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Gear14.displayName = 'Gear14';
export default Gear14;
